import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiOligon';
const args = {};

export class PetastiOligon extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
